<template>
    <div class="pt-2 pl-2">
        <v-row no-gutters>
            <v-col cols="6" class="pr-1">
                <v-card class="default_card_wm elevation-0 pt-2">
                    <DocumentMenu
                        :MenuOptions="documentMenuOptions"
                        @back="back()"
                        @zoom-out="zoomManager.zoomOut()"
                        @reset-zoom="zoomManager.resetZoom()"
                        @zoom-in="zoomManager.zoomIn()"
                        @rotate-left="
                            documentPdfRotation = rotate('left', zoomManager, documentPdfRotation)
                        "
                        @rotate-right="
                            documentPdfRotation = rotate('right', zoomManager, documentPdfRotation)
                        "
                        @ocr-changed="onOCRChanged()"
                        @clear-selected-text="emptySelectedText()"
                        @download="startDownloadFile()"
                        @display-item="showBankTransactions = true"
                        @display-document="showBankTransactions = false"
                        @analyse="analyseDocumentDialog = true"
                        @delete="deleteDocumentDialog = true"
                        v-model:selectedText="selectedText"
                    >
                    </DocumentMenu>
                    <v-row no-gutters>
                        <!--<v-col cols="6">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="mode !== 'GeneralLedger' && goBackHistory"
                                data-cy="document-back"
                            />
                            <v-btn-icon
                                icon="$oss-zoom-out"
                                :disabled="zoomManager.disableZoomOut()"
                                class="btn mr-1"
                                @click.stop="zoomManager.zoomOut()"
                                v-if="showZoomActions && !showBankTransactions"
                            />
                            <v-btn-icon
                                icon="$oss-focus"
                                :disabled="zoomManager.disableResetZoom()"
                                class="btn mx-1"
                                @click.stop="zoomManager.resetZoom()"
                                v-if="showZoomActions && !showBankTransactions"
                            />
                            <v-btn-icon
                                icon="$oss-zoom-in"
                                :disabled="zoomManager.disableZoomIn()"
                                class="btn ml-1"
                                @click.stop="zoomManager.zoomIn()"
                                v-if="showZoomActions && !showBankTransactions"
                            />
                            <v-btn-icon
                                icon="$oss-eye"
                                :disabled="zoomManager.disableResetZoom()"
                                class="ml-1"
                                :loading="ocrLoading"
                                @click.stop="onOCRChanged()"
                                v-if="document.signedUrlOCR && !showBankTransactions"
                            />
                            <v-btn-icon
                                class="my-0 mr-1"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'left',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-undo"
                            >
                            </v-btn-icon>
                            <v-btn-icon
                                class="my-0"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'right',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-redo"
                            >
                            </v-btn-icon>
                            <v-text-field-filled
                                v-model="selectedText"
                                v-show="selectedText"
                                id="selectedText"
                                hide-details
                                class="ml-2 small-prepend-icon"
                                append-inner-icon="$oss-close"
                                @click:append-inner="emptySelectedText"
                            />
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end">
                            <v-btn-icon
                                icon="$oss-download"
                                class="mx-1"
                                @click="startDownloadFile"
                            />
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon icon="$dots_vertical" v-bind="props" class="mx-1" />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item
                                        v-if="
                                            !showBankTransactions &&
                                            bankTransactions &&
                                            bankTransactions.length
                                        "
                                        @click="showBankTransactions = true"
                                    >
                                        <v-list-item-title
                                            >Voir les éléments importés</v-list-item-title
                                        >
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-eye</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="
                                            !fromEbics &&
                                            showBankTransactions &&
                                            bankTransactions &&
                                            bankTransactions.length
                                        "
                                        @click="showBankTransactions = false"
                                    >
                                        <v-list-item-title>Voir le document</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-eye</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="analyseDocumentDialog = true"
                                        v-if="restartAnalysis"
                                    >
                                        <v-list-item-title>Relancer l'analyse</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-scan</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="deleteDocumentDialog = true"
                                        :color="disabledDelete ? '' : 'error'"
                                    >
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>-->
                        <v-col
                            cols="12"
                            v-if="!showBankTransactions && isPDF"
                            class="d-flex justify-center"
                        >
                            <ossPdf :rotation="documentPdfRotation" :documentId="document.id" />
                        </v-col>
                        <v-col
                            cols="12"
                            style="max-height: 85vh; overflow-y: auto"
                            v-else-if="!showBankTransactions && document.signedUrl"
                        >
                            <div
                                style="
                                    position: relative;
                                    width: 100%;
                                    height: 0;
                                    padding: 0;
                                    padding-bottom: 141.4516129032258%;
                                    margin-bottom: 50px;
                                "
                            >
                                <svg
                                    id="svg-document-bank-statement-validation"
                                    v-if="document"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="100%"
                                    :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                    style="
                                        position: absolute;
                                        width: 100%;
                                        left: 0;
                                        top: 0;
                                        background: #fff;
                                    "
                                    :key="showOCR"
                                >
                                    <g>
                                        <image
                                            id="svg-image-document-bank-statement-validation"
                                            :xlink:href="document.signedUrl"
                                            x="0"
                                            y="0"
                                            :height="`${imageHeight}px`"
                                            :width="`${imageWidth}px`"
                                        />
                                        <template v-if="!showOCR">
                                            <template
                                                v-for="bt in identifiedBankTransactions"
                                                :key="`coord-${document.id}-${bt.index}`"
                                            >
                                                <polygon
                                                    :ref="`svg-bt-${bt.index}`"
                                                    :id="`svg-bt-${bt.index}`"
                                                    :points="getTokenPoints(bt)"
                                                    :style="
                                                        selectedBT && bt === selectedBT
                                                            ? 'fill:rgba(0,250,0,0.5);stroke:#F9B12A;stroke-width:1'
                                                            : 'fill:rgba(0,250,0,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                    "
                                                    @click.stop="onClickBT(bt)"
                                                    @mouseover="highlightBT(bt, true, 'identified')"
                                                    @mouseout="highlightBT(bt, false)"
                                                    :class="
                                                        bt.focus
                                                            ? 'highlighted'
                                                            : bt.amountSigned
                                                              ? ''
                                                              : 'error'
                                                    "
                                                />
                                            </template>
                                        </template>
                                        <template
                                            v-if="
                                                showOCR &&
                                                ocr &&
                                                ocr.sentences &&
                                                ocr.sentences.length
                                            "
                                        >
                                            <template v-for="(sentence, sIndex) in ocr.sentences">
                                                <template
                                                    v-for="(token, tIndex) in sentence.tokens"
                                                    :key="`sentence-${sIndex}-token-${tIndex}`"
                                                >
                                                    <polygon
                                                        :ref="`sentence-${sIndex}-token-${tIndex}`"
                                                        :points="getTokenPoints(token)"
                                                        :style="getTokenStyle(token)"
                                                        @mouseover="token.high = true"
                                                        @mouseout="token.high = false"
                                                        @click.stop="onClickToken(token)"
                                                    />
                                                </template>
                                            </template>
                                        </template>
                                    </g>
                                </svg>
                            </div>
                        </v-col>
                        <v-col
                            cols="12"
                            v-else-if="showBankTransactions"
                            class="d-flex justify-center"
                        >
                            <!-- {{ bankTransactions }} -->
                            <!-- <v-list two-line style="background-color: transparent" width="100%"> -->
                            <v-virtual-scroll
                                :item-height="75"
                                :items="bankTransactions"
                                height="750"
                                class="py-3"
                                bench="2"
                            >
                                <template v-slot="{ item }">
                                    <v-row
                                        no-gutters
                                        :key="item.id"
                                        inactive
                                        class="oss-list-item-inactive"
                                        style="background: rgb(246 246 246) !important"
                                    >
                                        <v-col
                                            cols="12"
                                            class="px-2 d-flex pb-1 font-weight-bold align-center"
                                        >
                                            <!-- <v-icon left color="secondary">$label</v-icon> -->
                                            <div
                                                style="
                                                    white-space: nowrap;
                                                    overflow: hidden;
                                                    text-overflow: ellipsis;
                                                    width: 50vw;
                                                "
                                            >
                                                {{ item.wordingOriginal }}
                                            </div>
                                        </v-col>
                                        <!-- </v-row>
                                                <v-row no-gutters> -->
                                        <v-col
                                            class="pl-2 d-flex align-center"
                                            v-if="item.dateRealization"
                                        >
                                            <!-- <v-icon  size="small" left color="secondary">$oss-calendar</v-icon> -->
                                            <span :style="dateStyle(item.dateRealization)">{{
                                                "Opération: " + formatDate(item.dateRealization)
                                            }}</span>
                                        </v-col>
                                        <v-col cols="3" class="pl-2 d-flex align-center">
                                            <!-- <v-icon  size="small" left color="secondary">$oss-calendar</v-icon> -->
                                            <span :style="dateStyle(item.dateDebit)">{{
                                                "Valeur: " + formatDate(item.dateDebit)
                                            }}</span>
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="pl-2 d-flex align-center justify-end"
                                        >
                                            <span v-if="item.amount > 0">{{
                                                newCommonFormatCurrency(item.amount, undefined)
                                            }}</span>
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="px-2 d-flex align-center justify-end"
                                        >
                                            <span v-if="item.amount < 0">{{
                                                newCommonFormatCurrency(-item.amount, undefined)
                                            }}</span>
                                        </v-col>
                                    </v-row>
                                    <!-- </v-list-item> -->
                                </template>
                            </v-virtual-scroll>
                            <!-- </v-list> -->
                        </v-col>
                    </v-row>
                </v-card>
                <v-list v-if="associatedFields.show" :style="svgPosition">
                    <v-list-item
                        v-for="(field, key, index) in associatedFields.fields"
                        :key="`field-${document.id}-${key}-${index}`"
                        @click="onFieldAssociation(field, key)"
                        class="oss-list-item"
                    >
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col cols="6" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                    "
                    class="default_card_wm fill-height elevation-0 rounded-l-0"
                >
                    <!-- <v-card-title>
                            <v-row no-gutters>
                                <v-col cols="12" class="headline">
                                    Détails du document
                                </v-col>
                            </v-row>
                        </v-card-title> -->
                    <v-card-text class="pt-0">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <!-- <div v-if="!document.errorMessage">En attente d'analyse par bobbee</div>
                                    <div v-else-if="reUploadDocument" style="color: red;">Erreur : {{document.errorMessage}}</div>
                                    <div v-else style="color: red;">Erreur de lecture du fichier : contacter votre cabinet</div> -->
                                <v-list single-line class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Statut</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div
                                                        v-if="document.errorMessage"
                                                        style="color: red"
                                                    >
                                                        Erreur : {{ document.errorMessage }}
                                                    </div>
                                                    <div
                                                        v-else-if="document.status === 'VALIDATED'"
                                                    >
                                                        Validé
                                                    </div>
                                                    <div v-else>{{ documentStatus }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :ripple="false"
                                        class="mb-2"
                                        color="success"
                                        v-if="document.data && document.data.bank"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Autres données</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <span
                                                        class="text-red"
                                                        v-if="
                                                            bankTransactions.length !==
                                                            document.data.bank
                                                                .toImportBankTransactionCount
                                                        "
                                                    >
                                                        <v-icon color="error" size="x-small" left
                                                            >$fa-exclamation-triangle</v-icon
                                                        >
                                                        Nombre de mouvements importés:
                                                        {{ bankTransactions.length }} /
                                                        {{
                                                            document.data.bank
                                                                .toImportBankTransactionCount
                                                        }}
                                                    </span>
                                                    <span v-else>
                                                        <v-icon
                                                            color="secondary"
                                                            size="x-small"
                                                            left
                                                            >$fa-check</v-icon
                                                        >
                                                        Nombre de mouvements importés:
                                                        {{ bankTransactions.length }} /
                                                        {{
                                                            document.data.bank
                                                                .toImportBankTransactionCount
                                                        }}
                                                    </span>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                                <v-row no-gutters>
                                    <v-col cols="3">
                                        <oss-date-picker-filled
                                            v-model="document.date"
                                            :hide-details="true"
                                            :label="$t('shared.date')"
                                            :mandatory="false"
                                            :textFieldReadOnly="false"
                                            prefixDataCy="DocumentBankStatement-documentDate"
                                        />
                                    </v-col>
                                    <v-col cols="9" class="pl-2">
                                        <v-select-filled
                                            :items="accounts"
                                            :item-title="formatBankAccount"
                                            item-value="id"
                                            label="Compte bancaire"
                                            v-model="selectedAccount"
                                            class="elevation-0"
                                            outlined
                                            hide-details
                                            :readonly="accounts.length <= 1 || fromEbics"
                                            density="compact"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <!-- <v-row no-gutters>
                                <v-col>
                                    <v-menu
                                        offset-y
                                        >
                                        <template v-slot:activator="{ on, props }">
                                            <v-input
                                            class="v-input v-input--hide-details v-input--is-label-active v-input--is-dirty v-input--is-readonly v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
                                            v-bind="props"
                                            v-on="on"
                                            hide-details
                                            background-color="#FFFFFF"
                                            >
                                                <div class="pt-2">{{ formatBankAccount(account) }}
                                                    <template v-if="account && account.currentError && account.currentError.length>0">
                                                        <span style="color:red;" >
                                                            - {{account.currentError}}
                                                        </span>
                                                    </template>
                                                </div>
                                            </v-input>
                                        </template>

                                        <v-list>
                                            <v-list-item
                                            v-for="(item, index) in accounts"
                                            :key="index"
                                            @click="selectedAccount = item.id"
                                            >
                                            <v-list-item-title>
                                                {{ formatBankAccount(item) }}
                                            </v-list-item-title>
                                            <template v-slot:append>
                                                <span style="color:red;" class="mr-4"
                                                >{{item.currentError}}</span>
                                            </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                            </v-row> -->
                        <v-row no-gutters v-if="analysisDone">
                            <v-col cols="12">
                                <v-row no-gutters class="pt-2">
                                    <v-col cols="3" class="d-flex align-center">
                                        <oss-text-field-filled
                                            label="Ancien Solde"
                                            regular
                                            dense
                                            :hide-details="true"
                                            outlined
                                            v-model="startBalance"
                                        >
                                        </oss-text-field-filled>
                                    </v-col>

                                    <v-col cols="3" class="d-flex align-center pl-2">
                                        <oss-text-field-filled
                                            regular
                                            label="Nouveau Solde"
                                            dense
                                            :hide-details="true"
                                            outlined
                                            v-model="endBalance"
                                        >
                                        </oss-text-field-filled>
                                        <!-- {{newCommonFormatCurrency(endBalance, undefined)}} -->
                                    </v-col>
                                    <v-col
                                        cols="3"
                                        class="d-flex align-center pl-2"
                                        style="border-right: 1px #ededed solid"
                                    >
                                        <v-text-field-filled
                                            regular
                                            :hide-details="true"
                                            outlined
                                            label="Calculé"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    computedEndBalance,
                                                    undefined,
                                                )
                                            "
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="1" class="d-flex align-center pl-2">
                                        <v-btn-icon
                                            :color="!endBalanceDelta ? 'primary' : 'red'"
                                            @click.stop="endBalanceValidated = !endBalanceValidated"
                                            :icon="
                                                endBalanceValidated
                                                    ? '$oss-circle-check'
                                                    : '$oss-circle-uncheck'
                                            "
                                            size="small"
                                        >
                                        </v-btn-icon>
                                    </v-col>
                                    <v-col cols="2" class="d-flex align-center pl-2 justify-end">
                                        <span style="color: red" v-if="endBalanceDelta">{{
                                            newCommonFormatCurrency(endBalanceDelta, undefined)
                                        }}</span>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters class="pt-2">
                                    <v-col cols="3" class="d-flex align-center"> </v-col>
                                    <v-col cols="3" class="d-flex align-center pl-2">
                                        <oss-text-field-filled
                                            regular
                                            dense
                                            :hide-details="true"
                                            outlined
                                            label="Total débit"
                                            v-model="totalDebit"
                                        >
                                        </oss-text-field-filled>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                        class="d-flex align-center pl-2"
                                        style="border-right: 1px #ededed solid"
                                    >
                                        <v-text-field-filled
                                            regular
                                            :hide-details="true"
                                            outlined
                                            label="Calculé"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    computedTotalDebit,
                                                    undefined,
                                                )
                                            "
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="1" class="d-flex align-center pl-2">
                                        <v-btn-icon
                                            :color="!totalDebitDelta ? 'primary' : 'red'"
                                            @click.stop="totalDebitValidated = !totalDebitValidated"
                                            :icon="
                                                totalDebitValidated
                                                    ? '$oss-circle-check'
                                                    : '$oss-circle-uncheck'
                                            "
                                            size="small"
                                        >
                                        </v-btn-icon>
                                    </v-col>
                                    <v-col cols="2" class="d-flex align-center pl-2 justify-end">
                                        <span style="color: red" v-if="totalDebitDelta">{{
                                            newCommonFormatCurrency(totalDebitDelta, undefined)
                                        }}</span>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters class="pt-2">
                                    <v-col cols="3" class="d-flex align-center"> </v-col>
                                    <v-col cols="3" class="d-flex align-center pl-2">
                                        <oss-text-field-filled
                                            regular
                                            dense
                                            :hide-details="true"
                                            outlined
                                            label="Total crédit"
                                            v-model="totalCredit"
                                        >
                                        </oss-text-field-filled>
                                    </v-col>
                                    <!-- <v-col cols="3" class="d-flex align-center justify-end pr-2" style="border-right: 1px #EDEDED solid;">
                                            Calculé
                                        </v-col> -->
                                    <v-col
                                        cols="3"
                                        class="d-flex align-center pl-2"
                                        style="border-right: 1px #ededed solid"
                                    >
                                        <v-text-field-filled
                                            regular
                                            :hide-details="true"
                                            outlined
                                            label="Calculé"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    computedTotalCredit,
                                                    undefined,
                                                )
                                            "
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="1" class="d-flex align-center pl-2">
                                        <v-btn-icon
                                            :color="!totalCreditDelta ? 'primary' : 'red'"
                                            @click.stop="
                                                totalCreditValidated = !totalCreditValidated
                                            "
                                            :icon="
                                                totalCreditValidated
                                                    ? '$oss-circle-check'
                                                    : '$oss-circle-uncheck'
                                            "
                                            size="small"
                                        >
                                        </v-btn-icon>
                                    </v-col>
                                    <v-col cols="2" class="d-flex align-center justify-end pl-2">
                                        <span style="color: red" v-if="totalCreditDelta">{{
                                            newCommonFormatCurrency(totalCreditDelta, undefined)
                                        }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-row no-gutters v-if="analysisDone">
                            <v-col class="d-flex align-center col-auto pr-3">
                                <span
                                    >Lignes bancaires ({{
                                        identifiedBankTransactions.length
                                    }})</span
                                >
                            </v-col>
                            <v-col class="pl-2 d-flex align-center">
                                <v-divider />
                            </v-col>
                            <v-col cols="1" class="pl-2 d-flex align-center justify-end">
                                <v-btn-add-icon size="x-small" @click="newBT()"> </v-btn-add-icon>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="analysisDone && errorCount">
                            <v-col class="d-flex align-center col-auto">
                                <span style="color: red"
                                    >Nombre d'erreur(s) : {{ errorCount }}</span
                                >
                            </v-col>
                            <v-spacer />
                            <!-- <v-col class="pl-2 d-flex align-center">
                                    <v-divider></v-divider>
                                </v-col> -->
                            <v-col cols="2" class="pl-2 d-flex align-center justify-end">
                                <v-switch
                                    hide-details="auto"
                                    v-model="filterErrorBTs"
                                    class="mt-0"
                                    label="Filtrer"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="analysisDone && duplicateCount">
                            <v-col class="d-flex align-center col-auto">
                                <span style="color: red"
                                    >Nombre de doublon(s) : {{ duplicateCount }}</span
                                >
                            </v-col>
                            <v-spacer />
                            <!-- <v-col class="pl-2 d-flex align-center">
                                    <v-divider></v-divider>
                                </v-col> -->
                            <v-col cols="3" class="pl-2 d-flex align-center justify-end">
                                <v-switch
                                    hide-details="auto"
                                    v-model="removeDuplicates"
                                    class="mt-0"
                                    label="Retirer"
                                />
                                <v-switch
                                    hide-details="auto"
                                    v-model="filterDuplicateBTs"
                                    class="ml-2 mt-0"
                                    label="Filtrer"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="analysisDone">
                            <v-col cols="12">
                                <v-list
                                    style="background-color: transparent; overflow-y: auto"
                                    width="100%"
                                    height="438"
                                    lines="two"
                                >
                                    <!-- <v-virtual-scroll
                                            :item-height="75"
                                            :items="identifiedBankTransactions"
                                            height="350"
                                            class="py-3"
                                            bench="2"
                                        >
                                            <template v-slot="{ item, index }">
                                                <v-lazy
                                                    v-model="item.isActive"
                                                    :options="{
                                                        threshold: .5
                                                    }"
                                                    transition="fade-transition"
                                                > -->
                                    <v-list-item
                                        v-for="item in filteredIdentifiedBankTransactions"
                                        :key="item.index"
                                        :class="
                                            item.focus
                                                ? 'oss-list-item1-high mb-2'
                                                : !item.errorCount
                                                  ? 'oss-list-item1 mb-2'
                                                  : 'oss-list-item1-error mb-2'
                                        "
                                        @click.stop="onClickBT(item)"
                                        @mouseover="highlightBT(item, true, 'svg')"
                                        @mouseout="highlightBT(item, false)"
                                        :id="'identified-bt-' + item.index"
                                        :active="false"
                                        :link="false"
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                class="d-flex pb-1 font-weight-bold align-center"
                                            >
                                                <!-- <v-icon left color="secondary">$label</v-icon> -->
                                                <v-btn-icon
                                                    color="primary"
                                                    @click.stop="item.selected = !item.selected"
                                                    size="small"
                                                    :icon="
                                                        item.selected
                                                            ? '$oss-circle-check'
                                                            : '$oss-circle-uncheck'
                                                    "
                                                >
                                                </v-btn-icon>
                                                <div style="overflow: hidden">
                                                    {{ item.wording }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                class="d-flex pb-1 font-weight-bold align-center"
                                                v-if="isDuplicates(item.index)"
                                            >
                                                <v-icon
                                                    :color="!removeDuplicates ? 'red' : 'green'"
                                                    size="small"
                                                >
                                                    $report_problem
                                                </v-icon>
                                                <span
                                                    class="pl-2"
                                                    :style="
                                                        !removeDuplicates
                                                            ? 'color:red;'
                                                            : 'color:green'
                                                    "
                                                    >{{
                                                        !removeDuplicates
                                                            ? "Doublon"
                                                            : "Doublon retiré"
                                                    }}</span
                                                >
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters>
                                            <v-col cols="4" class="px-1 d-flex align-center">
                                                <!-- <v-icon  size="small" left color="primary">$oss-calendar</v-icon> -->
                                                <span
                                                    :style="dateStyle(item.dateRealization)"
                                                    v-if="item.dateRealization"
                                                >
                                                    Opération : 
                                                    {{ formatDate(item.dateRealization) }}</span
                                                >
                                            </v-col>
                                            <v-col cols="4" class="px-1 d-flex align-center">
                                                <!-- <v-icon  size="small" left color="primary">$oss-calendar</v-icon> -->
                                                <span :style="dateStyle(item.dateDebit)">
                                                    Valeur : {{ formatDate(item.dateDebit) }}</span
                                                >
                                            </v-col>
                                            <v-col
                                                cols="2"
                                                class="px-1 d-flex align-center justify-end"
                                            >
                                                <span v-if="item.amountSigned < 0">{{
                                                    newCommonFormatCurrency(
                                                        -item.amountSigned,
                                                        undefined,
                                                    )
                                                }}</span>
                                            </v-col>
                                            <v-col
                                                cols="2"
                                                class="px-1 d-flex align-center justify-end"
                                            >
                                                <span v-if="item.amountSigned > 0">{{
                                                    newCommonFormatCurrency(
                                                        item.amountSigned,
                                                        undefined,
                                                    )
                                                }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <!-- </v-lazy> -->
                                    <!-- </template> -->
                                    <!-- </v-virtual-scroll> -->
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col v-if="activateTagguing">
                                <FreeTag
                                    :companyTags="allCompanyTags"
                                    :document="inDocument"
                                    :splitUserPartitions="true"
                                    @changed="startToBeDoneIfNecessary"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions v-if="mode !== 'GeneralLedger'">
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex align-center">
                                <v-switch
                                    v-model="onlyBalances"
                                    label="Importer uniquement les soldes bancaires"
                                />
                            </v-col>
                            <v-col cols="12" class="d-flex justify-end align-center">
                                <!-- <v-col cols="3"> -->
                                <!-- <oss-dialog
                                        title="Passer à la validation"
                                        @valid="switchToDocumentValidation()"
                                        width="40%"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="documentType === 'PURCHASE_INVOICE' || documentType === 'SALES_INVOICE' || documentType === 'EXPENSE_REPORT_DOCUMENT'"
                                                 size="small"
                                                color="primary"
                                                elevation="0"
                                                rounded
                                                v-on="on"
                                            >
                                                Passer à la validation
                                            </v-btn>
                                        </template>
                                        <template v-slot:content>
                                            Passer ce document en mode validation
                                        </template>
                                    </oss-dialog> -->
                                <!-- <v-btn
                                        v-if="documentType === 'PURCHASE_INVOICE' || documentType === 'SALES_INVOICE' || documentType === 'EXPENSE_REPORT_DOCUMENT'"
                                         size="small"
                                        color="primary"
                                        elevation="0"
                                        rounded
                                        @click="switchToDocumentValidation()"
                                    >
                                        Passer à la validation
                                    </v-btn> -->
                                <!-- </v-col> -->
                                <div id="ValidDocumentValidation" class="d-flex">
                                    <v-tooltip
                                        v-if="selectedCompany.solution !== 'MANAGEMENT'"
                                        location="top"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <v-btn-warning
                                                size="x-small"
                                                @click="setOpenChat('DENIED')"
                                                class="mr-1"
                                                :disabled="document.status === 'DENIED'"
                                                v-bind="props"
                                            >
                                            </v-btn-warning>
                                        </template>
                                        <span>Rejeter</span>
                                    </v-tooltip>
                                    <DocumentValidationSpeedRun
                                        v-if="displayDocumentValidationSpeedRun(document.status)"
                                        v-model="lastDocumentValidationDone"
                                    />
                                    <v-btn
                                        rounded
                                        class="elevation-0 ml-1"
                                        :disabled="disabledValidate"
                                        @click="onFormValidation()"
                                        :loading="loading"
                                        size="small"
                                    >
                                        {{ validated ? "Validé" : "Valider" }}
                                        <v-icon v-show="validated">$check</v-icon>
                                    </v-btn>
                                </div>
                                <v-btn-prev :disabled="previousDisabled()" @click="previous()" />
                                <v-btn-next :disabled="nextDisabled()" @click="next()" />
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <DocumentWizardDialog
            v-model:active="activeUploadDocument"
            v-bind:companyId="companyId"
            v-bind:documentId="document.id"
            v-bind:documentType="document.type"
            v-bind:showFirstPrevious="false"
            v-bind:multiple="false"
            @fileUploaded="onFileUploaded"
        />
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="analyseDocument"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</h4>
        </oss-dialog>
        <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="800px">
            Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

            <template v-slot:actions>
                <v-row no-gutters>
                    <v-col :cols="enableDownloadWorkingCopy ? 4 : 6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(true);
                            "
                            size="x-large"
                            >Original</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="4" class="px-2" v-if="enableDownloadWorkingCopy">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(true, true);
                            "
                            size="x-large"
                            >Travail (PNG)</v-btn-primary
                        >
                    </v-col>
                    <v-col :cols="enableDownloadWorkingCopy ? 4 : 6" class="pl-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(false);
                            "
                            size="x-large"
                            >Marqué</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            @valid="deleteDocument"
            :error="true"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="warningValidationDialog"
            title="Revalidation du document"
            @valid="
                validForm();
                warningValidationDialog = false;
            "
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">
                Si vous revalidez, certaines modifications apportées (affectation,
                lettrage,&#x2026;) peuvent être supprimées.
            </h4>
        </oss-dialog>
        <oss-dialog
            v-model="btDialog"
            title="Modifier la ligne bancaire"
            @valid="validateBT"
            @close="selectedBT = null"
            :validTitle="selectedBT ? 'Modifier' : 'Ajouter'"
            :validDisabled="!editBTIsValid"
            v-if="editBT"
            max-width="1200px"
            min-width="1000px"
        >
            <v-form v-model="editBTIsValid">
                <v-row no-gutters class="mx-2 pt-1">
                    <v-col :cols="$vuetify.display.mobile ? '12' : '2'" class="pb-2">
                        <oss-date-picker-filled
                            v-model="editBT.dateRealization"
                            :filterWithoutClosedAccountingPeriods="true"
                            hide-details
                            :textFieldReadOnly="false"
                            label="Opération"
                            prefixDataCy="DocumentBankStatement-dateRealization"
                        >
                        </oss-date-picker-filled>
                    </v-col>
                    <v-col :cols="$vuetify.display.mobile ? '12' : '2'" class="pl-2 pb-2">
                        <oss-date-picker-filled
                            v-model="editBT.dateDebit"
                            :filterWithoutClosedAccountingPeriods="true"
                            hide-details
                            :textFieldReadOnly="false"
                            label="Valeur"
                            prefixDataCy="DocumentBankStatement-dateDebit"
                        >
                        </oss-date-picker-filled>
                    </v-col>
                    <v-col :cols="$vuetify.display.mobile ? '12' : ''" class="pl-2 pb-2">
                        <v-text-field-filled
                            outlined
                            :hide-details="true"
                            v-model="editBT.wording"
                            single-line
                            :rules="[(v) => !!v || $t('settings.itemRequired')]"
                            density="compact"
                        />
                    </v-col>
                    <v-col :cols="$vuetify.display.mobile ? '12' : '2'" class="pl-2 pb-2">
                        <oss-text-field-filled
                            outlined
                            :hide-details="true"
                            suffix="&#x20ac;"
                            single-line
                            dense
                            :rules="[
                                (v) =>
                                    (!!v && editBT.amountSigned !== 0) ||
                                    $t('settings.itemRequired'),
                            ]"
                            v-model="editBT.amountSigned"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </oss-dialog>
        <!-- <Chat
                v-if="openChat"
                :id="document.chat ? document.chat.id : ''"
                :status="'INFORMATION_REQUEST'"
                :showSmartChat="false"
            ></Chat> -->
        <Chat
            v-if="openChat"
            :id="document.chat ? document.chat.id : ''"
            :inShowMessage="open_chat"
            :chatTitle="'Document'"
            :chatSubtitle="getChatSubTitle()"
            :showSmartChat="false"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";
// import axios from 'axios'
// import { State2Way } from '@/decorators'

import { Apollo } from "@/decorators";
// import { User } from '../../../../types'

import BANK_TRANSACTIONS_IMPORT_DOCUMENT from "../../graphql/bankTransaction/BankTransactionImportDocument.gql";
import IDENTIFY_TRANSACTION_DUPLICATES from "../../graphql/bankTransaction/IdentifyBankTransactionDuplicates.gql";
import UPDATE_DOCUMENT_MUTATION from "../../graphql/document/UpdateDocument.gql";

import { DocumentValidationBase } from "./DocumentValidationBase";
import { DocumentMenu } from "./DocumentMenu.vue";
import ossPdf from "./DocumentPDF.vue";
import DocumentWizardDialog from "./DocumentWizardDialog.vue";
import Chat from "../chat/Chat.vue";
import FreeTag from "../tag/FreeTag.vue";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { BankAccount } from "../../../../types";
import { getDBFormattedDate } from "@/services/dateServices";
import { Component, Watch, toNative } from "vue-facing-decorator";

import { DocumentValidationSpeedRun } from "./DocumentValidationSpeedRun.vue";
import { isNoValidatedDocument } from "./DocumentValidationSpeedRun.helper";
import {
    MenuDisplayDotMenuOptions,
    MenuDisplayDownloadOptions,
    MenuDisplayOCROptions,
    MenuDisplayOptions,
    MenuDisplayZoomOptions,
    MenuDisplayRotationOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

@Component({
    components: {
        DocumentWizardDialog,
        Chat,
        ossPdf,
        FreeTag,
        DocumentValidationSpeedRun,
        DocumentMenu,
    },
})
class DocumentBankStatement extends DocumentValidationBase {
    items: Array<any> = [];

    valid = false;

    loading = false;

    dialogSelectCompany = false;

    activeUploadDocument = false;

    showBankTransactions = false;

    onlyBalances: boolean = false;

    removeDuplicates: boolean = false;

    warningValidationDialog: boolean = false;

    get documentMenuZoomOptions(): MenuDisplayZoomOptions {
        const zoomOptions: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomOptions.isDisplay = this.showZoomActions && !this.showBankTransactions;
        zoomOptions.isZoomInDisabled = this.zoomManager.disableZoomIn();
        zoomOptions.isZoomOutDisabled = this.zoomManager.disableZoomOut();
        zoomOptions.isResetZoomDisabled = this.zoomManager.disableResetZoom();

        return zoomOptions;
    }

    get documentMenuOCROptions(): MenuDisplayOCROptions {
        const ocrOptions: MenuDisplayOCROptions = {
            ...documentMenuDisplayOptionsDefaultScheme.OCRButtons,
        };

        ocrOptions.isDisplay = this.document.signedUrlOCR && !this.showBankTransactions;
        ocrOptions.disabled = this.zoomManager.disableResetZoom();
        ocrOptions.isLoading = this.ocrLoading;

        return ocrOptions;
    }

    get documentMenuDownloadOptions(): MenuDisplayDownloadOptions {
        const downloadOptions: MenuDisplayDownloadOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.downloadButton,
        };

        downloadOptions.isDisplay = true;

        return downloadOptions;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenuOptions: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenuOptions.isDisplay = true;

        dotMenuOptions.document.isDisplay =
            !this.fromEbics &&
            this.showBankTransactions &&
            this.bankTransactions &&
            this.bankTransactions.length;
        dotMenuOptions.document.title = "Voir le document";

        dotMenuOptions.items.isDisplay =
            !this.showBankTransactions && this.bankTransactions && this.bankTransactions.length;
        dotMenuOptions.items.title = "Voir les éléments importés";

        dotMenuOptions.analyse.isDisplay = this.restartAnalysis;
        dotMenuOptions.analyse.title = "Relancer l'analyse";

        dotMenuOptions.delete.isDisplay = true;
        dotMenuOptions.delete.title = "Supprimer";

        return dotMenuOptions;
    }

    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        let rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };
        rotationButton.isDisplay = this.showRotateActions && !this.showBankTransactions;

        return rotationButton;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = {
            ...documentMenuDisplayOptionsDefaultScheme,
        };

        documentMenuOption.zoomButtons = this.documentMenuZoomOptions;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.OCRButtons = this.documentMenuOCROptions;
        documentMenuOption.isSelectedText = true;
        documentMenuOption.downloadButton = this.documentMenuDownloadOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    get reUploadDocument() {
        if (!this.document) return false;
        if (this.currentUser.profile.configuration.document.write) {
            return true;
        }
        return false;
    }

    startBalance = null;
    endBalance = null;
    totalDebit = null;
    totalCredit = null;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    @Apollo({
        query: gql`
            query BankAccountsQuery($companyId: ID!) {
                bankAccounts(where: { company: { id: $companyId } }) {
                    id
                    name
                    balance
                    initialSyncDone
                    currentError
                    number
                    balances(orderBy: date_DESC, first: 1) {
                        balance
                    }
                    bank {
                        id
                        name
                    }
                    type
                    budgetInsightId
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.bankAccounts) {
                    if (!data || !data.bankAccounts || data.bankAccounts.length === 0) {
                        this.accounts = [];
                        this.selectedAccount = "";
                    } else {
                        // const total_balance = mathFix(data.bankAccounts.reduce((acc, e) => acc + e.balance,0));
                        // debugger
                        this.accounts = data.bankAccounts;
                        // this.accounts = [
                        //     {
                        //         name: "Tous les comptes",
                        //         balance: total_balance,
                        //         id: "ALL"
                        //     },
                        //     ...data.bankAccounts
                        // ];
                        if (this.selectedAccount) {
                            if (!this.accounts.find((a) => a.id === this.selectedAccount)) {
                                this.selectedAccount = "";
                            }
                        }
                        if (!this.selectedAccount && this.accounts.length) {
                            if (this.document.data && this.document.data.bankAccountId) {
                                if (
                                    this.accounts.find(
                                        (a) => a.id === this.document.data.bankAccountId,
                                    )
                                ) {
                                    this.selectedAccount = this.document.data.bankAccountId;
                                }
                            }
                            if (!this.selectedAccount) {
                                this.selectedAccount = this.accounts[0].id;
                            }
                        }
                    }
                } else {
                    this.accounts = [];
                    this.selectedAccount = "";
                }
            }
        },
    })
    accounts: BankAccount[] = [];

    selectedAccount = "";

    get account(): any {
        if (!this.selectedAccount) {
            return null;
        }
        if (!this.accounts.length) {
            return null;
        }
        return this.accounts.find((a) => a.id === this.selectedAccount);
    }

    get analysisDone() {
        return this.analysis;
        // return (
        //     this.analysis &&
        //     (!this.selectedAccount ||
        //         this.identifiedBankTransactions.length === this.analysedBankTransactions.length)
        // );
    }

    filterErrorBTs: boolean = false;
    filterDuplicateBTs: boolean = false;

    get duplicateCount() {
        let count = 0;
        for (const bt of this.analysedBankTransactions) {
            if (bt.duplicate) {
                count++;
            }
        }
        return count;
    }

    get errorCount() {
        let errorCount = 0;
        for (const bt of this.identifiedBankTransactions) {
            errorCount += bt.errorCount || 0;
        }
        return errorCount;
    }

    identifiedBankTransactions = [];

    get filteredIdentifiedBankTransactions() {
        if (this.filterErrorBTs || this.filterDuplicateBTs) {
            const bts = [];
            for (const bt of this.identifiedBankTransactions) {
                if (this.filterErrorBTs) {
                    if (bt.errorCount) {
                        if (this.filterDuplicateBTs) {
                            if (this.isDuplicates(bt.index)) {
                                bts.push(bt);
                            }
                        } else {
                            bts.push(bt);
                        }
                    }
                } else if (this.filterDuplicateBTs) {
                    if (this.isDuplicates(bt.index)) {
                        bts.push(bt);
                    }
                }
            }
            return bts;
        }
        return this.identifiedBankTransactions;
    }

    @Apollo({
        query: BANK_TRANSACTIONS_IMPORT_DOCUMENT,
        variables() {
            return {
                companyId: this.companyId,
                documentId: this.documentId,
            };
        },
        skip() {
            return !this.companyId;
        },
    })
    bankTransactions: any = [];

    @Apollo({
        query: IDENTIFY_TRANSACTION_DUPLICATES,
        variables() {
            return {
                documentId: this.document.id,
                bankAccountId: this.selectedAccount,
                bankTransactions: this.identifiedBankTransactions,
            };
        },
        skip() {
            return (
                !this.document.id ||
                !this.selectedAccount ||
                !this.identifiedBankTransactions ||
                !this.identifiedBankTransactions.length
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (
                data &&
                data.identifyBankTransactionDuplicates &&
                data.identifyBankTransactionDuplicates.bankTransactions
            ) {
                this.analysedBankTransactions =
                    data.identifyBankTransactionDuplicates.bankTransactions;
                // code to test duplicates
                // let index = 0
                // for (const bt of this.analysedBankTransactions ) {
                //     let c = index % 3
                //     if (!c) {
                //         bt.duplicate = true
                //     }
                //     index ++
                // }
            } else {
                this.analysedBankTransactions = [];
            }
        },
    })
    analysedBankTransactions: any = [];

    isDuplicates(index) {
        if (index < 0 || index >= this.analysedBankTransactions.length) {
            return false;
        }
        return this.analysedBankTransactions[index].duplicate;
    }

    get duplicatesCount() {
        let count = 0;
        for (const abt of this.analysedBankTransactions) {
            if (abt.duplicate) {
                count++;
            }
        }
        return count;
    }

    get fromEbics() {
        return this.isCSV;
    }

    onFileUploaded() {
        // this.uploadFileLoading = false;
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        await this.onDocumentChangedCommon(prev, next);
        if (this.isCSV) {
            this.showBankTransactions = true;
        }
        this.finishMounted();
        if (prev !== next) {
            this.onAnalysisChanged();
        }
    }

    onAnalysisChanged() {
        const inputData = this.inDocument.data?.bankTransactions
            ? this.inDocument.data
            : this.analysis;
        if (inputData) {
            const identifiedBankTransactions = inputData.bankTransactions;
            if (identifiedBankTransactions) {
                let index = 0;
                for (const bt of identifiedBankTransactions) {
                    bt.index = index;
                    if (bt.focus === undefined) {
                        bt.focus = false;
                    }
                    if (bt.selected === undefined) {
                        bt.selected = true;
                    }
                    bt.errorCount = 0;

                    if (!moment(bt.dateDebit).isValid()) {
                        bt.errorCount++;
                    }
                    if (!moment(bt.dateRealization).isValid()) {
                        bt.errorCount++;
                    }
                    if (!bt.amountSigned) {
                        bt.errorCount++;
                    }
                    if (!bt.wording) {
                        bt.errorCount++;
                    }
                    index++;
                }
                this.identifiedBankTransactions = identifiedBankTransactions;
            } else {
                this.identifiedBankTransactions = [];
            }
            debugger;
            if (inputData.totalDebit !== undefined) {
                this.totalDebit = inputData.totalDebit;
            }
            if (inputData.totalCredit !== undefined) {
                this.totalCredit = inputData.totalCredit;
            }
            if (inputData.startBalance !== undefined) {
                this.startBalance = inputData.startBalance;
            }
            if (inputData.endBalance !== undefined) {
                this.endBalance = inputData.endBalance;
            }
            if (this?.inDocument?.data?.onlyBalances) {
                this.onlyBalances = this.inDocument.data.onlyBalances;
            } else this.onlyBalances = false;
            if (this?.inDocument?.data?.removeDuplicates) {
                this.removeDuplicates = this.inDocument.data.removeDuplicates;
            } else this.removeDuplicates = false;
        }
    }

    beforeMount() {
        this.svgSuffix = "document-bank-statement-validation";
        this.onDocumentChanged(this.inDocument.id, undefined);
    }

    //
    // endBalance
    //

    endBalanceValidated_ = null;

    get endBalanceValidated() {
        if (this.endBalanceValidated_ !== null) {
            return this.endBalanceValidated_;
        }
        return this.endBalanceDelta === undefined ? false : !this.endBalanceDelta;
    }

    set endBalanceValidated(value) {
        if (
            value &&
            (Math.abs(this.endBalanceDelta) >= 1e-2 || this.endBalanceDelta === undefined)
        ) {
            return;
        }
        this.endBalanceValidated_ = value;
    }

    get computedEndBalance() {
        let computedEndBalance;
        if (this.analysis && this.startBalance !== undefined && this.identifiedBankTransactions) {
            computedEndBalance = this.startBalance;
            for (const bt of this.identifiedBankTransactions) {
                if (bt.selected) {
                    computedEndBalance += bt.amountSigned;
                }
            }
        }
        return computedEndBalance;
    }

    get endBalanceDelta() {
        if (this.analysis && this.startBalance !== null && this.endBalance !== null) {
            return Math.round((this.endBalance - this.computedEndBalance) * 100) / 100;
        }
        return undefined;
    }

    //
    // total debit
    //

    totalDebitValidated_ = null;

    get totalDebitValidated() {
        if (this.totalDebitValidated_ !== null) {
            return this.totalDebitValidated_;
        }
        return this.totalDebitDelta === undefined ? false : !this.totalDebitDelta;
    }

    set totalDebitValidated(value) {
        if (
            value &&
            (Math.abs(this.totalDebitDelta) >= 1e-2 || this.totalDebitDelta === undefined)
        ) {
            return;
        }
        this.totalDebitValidated_ = value;
    }

    getDelta(a, b) {
        if (a && b) {
            return Math.round((a - b) * 100) / 100;
        }
        return undefined;
    }

    get computedTotalDebit() {
        let amount;
        if (this.analysis && this.identifiedBankTransactions) {
            amount = 0;
            for (const bt of this.identifiedBankTransactions) {
                if (bt.selected && bt.amountSigned < 0) amount -= bt.amountSigned;
            }
            const prevAmount = amount;
            //
            // correct if necessary and possible with startBalance
            //
            if (this.getDelta(this.totalDebit, amount)) {
                if (this.startBalance < 0) {
                    amount -= this.startBalance;
                    if (this.getDelta(this.totalDebit, amount)) {
                        amount = prevAmount;
                    }
                }
            }
            return amount;
        }
    }

    get totalDebitDelta() {
        if (this.analysis && this.totalDebit !== null) {
            return Math.round((this.totalDebit - this.computedTotalDebit) * 100) / 100;
        }
        return undefined;
    }
    //
    // credit
    //

    totalCreditValidated_ = null;

    get totalCreditValidated() {
        if (this.totalCreditValidated_ !== null) {
            return this.totalCreditValidated_;
        }
        return this.totalCreditDelta === undefined ? false : !this.totalCreditDelta;
    }

    set totalCreditValidated(value) {
        if (
            value &&
            (Math.abs(this.totalCreditDelta) >= 1e-2 || this.totalCreditDelta === undefined)
        ) {
            return;
        }
        this.totalCreditValidated_ = value;
    }

    get computedTotalCredit() {
        let amount;
        if (this.analysis && this.identifiedBankTransactions) {
            amount = 0;
            for (const bt of this.identifiedBankTransactions) {
                if (bt.selected && bt.amountSigned > 0) {
                    amount += bt.amountSigned;
                }
            }
            //
            // correct if necessary and possible with startBalance
            //
            const prevAmount = amount;
            if (this.getDelta(this.totalCredit, amount)) {
                if (this.startBalance > 0) {
                    amount += this.startBalance;
                    if (this.getDelta(this.totalCredit, amount)) {
                        amount = prevAmount;
                    }
                }
            }
        }
        return amount;
    }

    get totalCreditDelta() {
        if (this.analysis && this.totalCredit !== null) {
            const delta = Math.round((this.totalCredit - this.computedTotalCredit) * 100) / 100;
            return delta;
        }
        return undefined;
    }

    //
    //
    //

    get validated() {
        return this.inDocument.status === "VALIDATED";
    }

    get disabledValidate() {
        if (this.documentIsInAccountingClosing) {
            return true;
        }
        if (!this.endBalanceValidated) {
            return true;
        }
        if (!this.totalDebitValidated) {
            return true;
        }
        if (!this.totalCreditValidated) {
            return true;
        }
        if (!this.selectedAccount) {
            return true;
        }
        return false;
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "type";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }

    formatBankAccount(bankAccount) {
        if (!bankAccount) return "";
        // debugger
        let name = "";
        if (bankAccount.bank) {
            name = bankAccount.bank.name + " : ";
        }
        name += `${bankAccount.name} (${newCommonFormatCurrency(bankAccount.balance)})`;
        return name;
    }

    dateStyle(date) {
        if (!date) {
            return "color:red; font-weight:bold;";
        }
        return moment(date).isValid() ? "" : "color:red; font-weight:bold;";
    }

    async onFormValidation() {
        debugger;
        if (this.validated) {
            this.warningValidationDialog = true;
            return;
        }
        await this.validForm();
    }

    //
    // update
    //
    async validForm() {
        this.updating = true;

        const data = {
            bankAccountId: this.selectedAccount,
            removeDuplicates: this.removeDuplicates,
            onlyBalances: this.onlyBalances,

            bankTransactions: this.identifiedBankTransactions,
            startBalance: this.startBalance,
            endBalance: this.endBalance,
            totalDebit: this.totalDebit,
            totalCredit: this.totalCredit,
        };

        // debugger
        const variables = {
            documentId: this.documentId,
            type: this.document.type,
            creditNote: false,
            vatType: null,
            multiVat: false,
            status: "VALIDATED",
            date: this.document.date ? getDBFormattedDate(this.document.date) : undefined,

            data,

            grossAmount: null,
            grossAmountSigned: null,

            netAmount: null,
            netAmountSigned: null,
            vatAmount: null,
            vatAmountSigned: null,
            vatRate: null,
            vatAmount1: null,
            netAmount1: null,
            grossAmount1: null,
            vatRate1: null,
            vatAmount2: null,
            netAmount2: null,
            grossAmount2: null,
            vatRate2: null,
            vatAmount3: null,
            netAmount3: null,
            grossAmount3: null,
            vatRate3: null,
        };

        await this.$apollo.mutate({
            mutation: UPDATE_DOCUMENT_MUTATION,
            variables: variables,
        });
        // debugger;

        await this.createUserActivity(this.document.id, "UPDATE");

        this.updating = false;
        this.loading = false;

        this.startToBeDoneIfNecessary();
    }

    enableDownloadWorkingCopy() {
        return this.document.workingCopy;
    }

    highlightBT(item, state: boolean, prefix: string = "") {
        item.focus = state;
        if (state && prefix) {
            const id = prefix + "-bt-" + item.index;
            const elem = document.getElementById(id);
            if (elem) {
                elem.scrollIntoView({ block: "center", behavior: "smooth" });
            }
        }
    }

    //
    //
    //
    editBTIsValid: boolean = false;
    selectedBT = null;
    editBT = {
        index: -1,
        focus: false,
        selected: false,
        dateDebit: "",
        dateRealization: "",
        amountSigned: 0.0,
        wording: "",
    };
    btDialog: boolean = false;

    onClickBT(item) {
        this.selectedBT = item;
        this.editBT = {
            index: -1,
            focus: this.selectedBT.focus,
            selected: this.selectedBT.selected,
            dateDebit: this.selectedBT.dateDebit,
            dateRealization: this.selectedBT.dateRealization,
            amountSigned: this.selectedBT.amountSigned,
            wording: this.selectedBT.wording,
        };
        this.btDialog = true;
    }

    newBT() {
        this.selectedBT = null;
        this.editBT = {
            index: -1,
            focus: false,
            selected: true,
            dateDebit: "",
            dateRealization: "",
            amountSigned: 0.0,
            wording: "",
        };
        this.btDialog = true;
    }

    validateBT() {
        debugger;
        if (this.selectedBT) {
            this.selectedBT.selected = true;
            this.selectedBT.dateDebit = this.editBT.dateDebit;
            this.selectedBT.dateRealization = this.editBT.dateRealization;
            this.selectedBT.amountSigned = this.editBT.amountSigned;
            this.selectedBT.wording = this.editBT.wording;
        } else {
            let maxIndex = -1;
            for (const bt of this.identifiedBankTransactions) {
                if (maxIndex < bt.index) {
                    maxIndex = bt.index;
                }
            }
            this.editBT.index = maxIndex + 1;
            this.identifiedBankTransactions.push({ ...this.editBT });
        }
        this.btDialog = false;
        // console.log("Updated identifiedBankTransactions:", this.identifiedBankTransactions);
        // console.log("showOCR:", this.showOCR);
    }

    displayDocumentValidationSpeedRun(documentStatus: string) {
        return isNoValidatedDocument(documentStatus);
    }
}

export default toNative(DocumentBankStatement);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

polygon.error {
    fill: rgba(255, 0, 0, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}

.oss-list-item1 {
    background-color: #e5e5e5 !important;
    border: 1px #ededed solid !important;
    border-radius: 8px !important;
}

.oss-list-item1-high {
    background-color: rgba(249, 177, 42, 0.5) !important;
    border: 1px #f9b12a solid !important;
    border-radius: 8px !important;
}
.oss-list-item1-error {
    background-color: rgba(255, 0, 0, 0.5) !important;
    border: 1px #f9b12a solid !important;
    border-radius: 8px !important;
}
</style>
